import { ShoppingBag, Globe, TrendingUp, Handshake, CheckCircle, Clock, Award, Users } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { lazy, Suspense } from 'react'
import SEO from '../components/SEO'
import { serviceSEOData } from '../utils/serviceSEO'

// ✅ Import images to ensure they work in production
import hero1 from '../assets/Services/general-trading/hero-1.jpg'
import hero2 from '../assets/Services/general-trading/hero-2.jpg'
import hero3 from '../assets/Services/general-trading/hero-3.jpg'
import importExportImg from '../assets/Services/general-trading/import-export.jpg'
import distributionImg from '../assets/Services/general-trading/distribution.jpg'
import procurementImg from '../assets/Services/general-trading/procurement.jpg'
import marketAnalysisImg from '../assets/Services/general-trading/market-analysis.jpg'

const ServicePageLayout = lazy(() => import('../components/ServicePageLayout'))

const GeneralTrading = () => {
  const { t } = useTranslation()

  const service = {
    heroSlides: [
      {
        image: hero1, // ✅ Use imported variable
        title: t('generalTrading.heroSlides.0.title'),
        subtitle: t('generalTrading.heroSlides.0.subtitle'),
        description: t('generalTrading.heroSlides.0.description')
      },
      {
        image: hero2,
        title: t('generalTrading.heroSlides.1.title'),
        subtitle: t('generalTrading.heroSlides.1.subtitle'),
        description: t('generalTrading.heroSlides.1.description')
      },
      {
        image: hero3,
        title: t('generalTrading.heroSlides.2.title'),
        subtitle: t('generalTrading.heroSlides.2.subtitle'),
        description: t('generalTrading.heroSlides.2.description')
      }
    ],
    introText: t('generalTrading.introText'),
    stats: [
      { value: "100%", label: t('logistics.stats.coverage') },
      { value: "24/7", label: t('logistics.stats.support') },
      { value: t('logistics.stats.global'), label: t('logistics.stats.network') },
      { value: t('logistics.stats.secure'), label: t('logistics.stats.handling') }
    ],
    capabilities: t('generalTrading.capabilities', { returnObjects: true }),
    services: [
      {
        icon: Globe,
        title: t('generalTrading.services.importExport.title'),
        description: t('generalTrading.services.importExport.description'),
        image: importExportImg // ✅ Use imported variable
      },
      {
        icon: TrendingUp,
        title: t('generalTrading.services.commodityTrading.title'),
        description: t('generalTrading.services.commodityTrading.description'),
        image: distributionImg
      },
      {
        icon: Handshake,
        title: t('generalTrading.services.customizedSolutions.title'),
        description: t('generalTrading.services.customizedSolutions.description'),
        image: procurementImg
      },
      {
        icon: ShoppingBag,
        title: t('generalTrading.services.marketIntelligence.title'),
        description: t('generalTrading.services.marketIntelligence.description'),
        image: marketAnalysisImg
      }
    ],
    workflow: [
      {
        step: "01",
        title: t('generalTrading.workflow.0.title'),
        description: t('generalTrading.workflow.0.description')
      },
      {
        step: "02",
        title: t('generalTrading.workflow.1.title'),
        description: t('generalTrading.workflow.1.description')
      },
      {
        step: "03",
        title: t('generalTrading.workflow.2.title'),
        description: t('generalTrading.workflow.2.description')
      },
      {
        step: "04",
        title: t('generalTrading.workflow.3.title'),
        description: t('generalTrading.workflow.3.description')
      }
    ]
  }

  return (
    <>
      <SEO {...serviceSEOData['general-trading']} url="/services/general-trading" />
      <Suspense fallback={<div className="min-h-screen flex items-center justify-center">Loading...</div>}>
        <ServicePageLayout
        title={service.heroSlides[0].title}
        subtitle={service.heroSlides[0].subtitle}
        description={service.heroSlides[0].description}
        backgroundImages={service.heroSlides.map(slide => slide.image)}
        heroSlides={service.heroSlides}
        introText={service.introText}
        capabilities={service.capabilities}
        services={service.services}
        stats={service.stats}
        workflow={service.workflow}
        />
      </Suspense>
    </>
  )
}

export default GeneralTrading